import React, { useContext, useEffect, useState } from 'react';
import {
    Button,
    TextField,
    MenuItem,
    Select,
    InputLabel,
    FormControl,
    Grid,
    filledInputClasses,
} from '@mui/material';
import Autocomplete from "@mui/material/Autocomplete";
import { errorAlert, handleSuccess } from '../../../Components/Alerts';
import { ApiLink } from '../../../APILink/ApiLink';
import axios from 'axios';
import authHeader from '../../../Auth/authHeader';
import { FiscalYearContext } from '../../../FiscalYear/FiscalYearContext';
import CancelModal from '../../../Components/CancelModal';

export const positions = [
    "Drejtor Ekzekutiv (CEO)",
    "Drejtor Financiar (CFO)",
    "Drejtor Operacional (COO)",
    "Shef Departamenti",
    "Menaxher",
    "Asistent Menaxheri",
    "Koordinator",
    "Konsulent",
    "Trajner / Instruktor",
    "Analist",
    "Specialist / Ekspert",
    "Inxhinier",
    "Programues / Zhvillues Softueri",
    "Kontabilist",
    "Arkëtar",
    "Përfaqësues Shitjesh",
    "Asistent Administrativ",
    "Sekretar / Sekretare",
    "Operator / Teknik",
    "Staf Mbështetës",
    "Punëtor i Përgjithshëm",
    "Pastrues"
]

export const departments = [
    "Zyra Ekzekutive",
    "Financë & Kontabilitet",
    "Shitje & Marketing",
    "IT & Zhvillim Softueri",
    "Burime Njerëzore",
    "Prodhim / Operacione",
    "Shërbimi ndaj Klientit",
    "Logjistikë & Transport",
    "Menaxhim Projekte",
    "Administratë",
    "Ligjor / Juridik",
    "Kërkim & Zhvillim(R & D)",
    "Kontrolli i Cilësisë",
    "Siguri dhe Mbrojtje",
    "Kreativ / Dizajn",
    "E - commerce"
]

const ContractForm = ({ onGenerate, onClearContract, accountId }) => {
    const headers = authHeader();
    const [employees, setEmployees] = useState([]);
    const { fiscalYear } = useContext(FiscalYearContext);
    const [contractExist, setContractExist] = useState(false);
    const today = new Date().toISOString().split('T')[0]; // format: yyyy-mm-dd
    const [selectedEmployee, setSelectedEmployee] = useState([]);
    const [allAccountsContracts, setAllAccountsContracts] = useState([]);
    const [showModal, setShowModal] = useState(false);

    const [contractID, setContractID] = useState(null);

    const [showContractSelectList, setShowContractSelectList] = useState(false);
    const [selectedContractId, setSelectedContractId] = useState('');
    const [inputDisable, setInputDisable] = useState(false);
    const [endDateDisabled, setEndDateDisabled] = useState(false);
    const [showInsertBtn, setShowInsertBtn] = useState(true);
    const [showEditBtn, setShowEditBtn] = useState(false);

    const [owner, setOwner] = useState([]);

    const [formData, setFormData] = useState({
        accountId: '',
        contractNumber: '',
        contractType: 'KOHË TË PACAKTUAR',
        startDate: '',
        endDate: '',
        employeeRole: 'Primare',
        salaryGross: 0,
        salaryNet: 0,
        position: '',
        jobDuties: '',
        department: '',
        authorizedSignatory: '',
        workingHoursPerWeek: '40',
        foreignTravelCompensation: '50',
        contractSignedDate: today,
    });

    const [accountName, setAccountName] = useState("");
    const [identificationNumber, setIdentificationNumber] = useState("");
    const [empAddress, setEmpAddress] = useState("");

    const fetchEmployees = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Accounts/accountByLedger', { headers, params: { ledger: 310 } });
            setEmployees(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const getcontractByAccount = async (accountId, type) => {
        try {
            const response = await axios.get(`${ApiLink.API_URL}EmployeeContracts/byID/${accountId}`, {
                headers
            });

            if (response.data) {
                // Nëse kthehet një kontratë
                setShowInsertBtn(false);
                setInputDisable(false);
                if (response.data.ContractType === "KOHË TË PACAKTUAR") {
                    setEndDateDisabled(true);
                }
                setContractExist(true);
                if (type === "onlyID") {
                    setContractID(response.data.ContractID);
                }
                else {
                    setFormData(() => ({
                        accountId: response.data.AccountID,
                        contractNumber: response.data.ContractNumber,
                        contractType: response.data.ContractType,
                        startDate: response.data.StartDate,
                        endDate: response.data.EndDate,
                        employeeRole: response.data.EmployeeRole,
                        salaryGross: response.data.SalaryGross,
                        salaryNet: response.data.SalaryNet,
                        position: response.data.Position,
                        jobDuties: response.data.JobDuties,
                        department: response.data.Department,
                        authorizedSignatory: response.data.AuthorizedSignatory,
                        workingHoursPerWeek: response.data.WorkingHoursPerWeek,
                        foreignTravelCompensation: response.data.ForeignTravelCompensation,
                        contractSignedDate: response.data.ContractSignedDate,
                    }))
                    setContractID(response.data.ContractID);
                }
            } else {
                // Nëse nuk kthehet asgjë
                setShowInsertBtn(true);
                fetchOwner();
                fetchNextInvNumber();
                setContractExist(false);
                setContractID(null);
                if (response.data.ContractType === "KOHË TË PACAKTUAR") {
                    setEndDateDisabled(true);
                }

                setFormData(() => ({
                    accountId: accountId,
                    contractNumber: '',
                    contractType: 'KOHË TË PACAKTUAR',
                    startDate: '',
                    endDate: '',
                    employeeRole: 'Primare',
                    salaryGross: '',
                    salaryNet: '',
                    position: '',
                    jobDuties: '',
                    department: '',
                    workingHoursPerWeek: '40',
                    foreignTravelCompensation: '50',
                    contractSignedDate: today,
                }))
            }

        } catch (error) {
            if (error.response && error.response.status === 404) {
                console.log("Kontrata nuk ekziston për këtë accountId");
            } else {
                console.error("Gabim tjetër:", error);
            }
        }
    };

    const fetchNextInvNumber = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'EmployeeContracts/nextContractNumber', { headers });
            var number = response.data.NextContractNumber;
            setFormData((prev) => ({
                ...prev,
                contractNumber: number
            }))
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const fetchAllContractByAccID = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'EmployeeContracts/contractsByAccID', {
                headers,
                params: { id: accountId }
            });

            // Nëse nuk ka kontrata, vendos listën si bosh
            if (response.data && Array.isArray(response.data)) {
                setAllAccountsContracts(response.data); // Mund të jetë array bosh dhe kjo është ok

                if (response.data.length > 1) {
                    setShowContractSelectList(true);
                } else {
                    setShowContractSelectList(false);
                }
            } else {
                setAllAccountsContracts([]); // nëse përgjigja nuk është array, e vendosim bosh për siguri
            }

        } catch (error) {
            // Gabimet e rrjetit ose të serverit vërtet duhen raportuar
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
            console.error("Gabim gjatë fetchAllContractByAccID:", error);
        }
    };

    const fetchOwner = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Accounts/accountByLedger', {
                headers,
                params: { ledger: 501 }
            });

            const accounts = response.data;
            setOwner(accounts);
            if (accounts.length > 0) {
                setFormData(prev => ({
                    ...prev,
                    authorizedSignatory: accounts[0].AccountName
                }));
            }

        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);

            if (error.response?.data?.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };


    const generateNewContract = (e) => {
        e.preventDefault(); // ndalon submit-in
        setShowInsertBtn(true);
        fetchNextInvNumber();
        setInputDisable(false);
        fetchOwner();
        setContractExist(false);
        setShowEditBtn(false);
        setContractID(null);
        if (formData.contractType === "KOHË TË PACAKTUAR") {
            setEndDateDisabled(true);
        }
        else {
            setEndDateDisabled(false);
        }
        setFormData(() => ({
            accountId: selectedEmployee.AccountID,
            contractNumber: '',
            contractType: 'KOHË TË PACAKTUAR',
            startDate: '',
            endDate: '',
            employeeRole: 'Primare',
            salaryGross: '',
            salaryNet: '',
            position: '',
            jobDuties: '',
            department: '',
            workingHoursPerWeek: '40',
            foreignTravelCompensation: '50',
            contractSignedDate: today,
        }));
        if (onClearContract) {
            onClearContract(); // mbyll display-n
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        setShowEditBtn(true);
    };

    // const handleSelectChange = (name, value) => {
    //     setFormData((prev) => ({ ...prev, [name]: value }));
    // };

    const handleSelectChange = (name, value) => {
        setFormData(prev => ({ ...prev, [name]: value }));

        if (name === "employeeRole") {
            calculateSalaryOnRoleChange(value);
        }
    };

    const calculateSalaryOnRoleChange = (role) => {
        // Nëse kemi bruto dhe neto në formData
        const bruto = formData.salaryGross;
        const neto = formData.salaryNet;

        if (bruto && neto) {
            calculateFromBruto(bruto, role);
        } else if (bruto) {
            calculateFromBruto(bruto, role);
        } else if (neto) {
            calculateFromNeto(neto, role);
        }
    };


    const handleContractSelect = (contractId) => {
        setSelectedContractId(contractId);
        const selectedContract = allAccountsContracts.find(c => c.ContractID === contractId);
        if (selectedContract) {
            setFormData(prev => ({
                accountId: selectedContract.AccountID,
                contractNumber: selectedContract.ContractNumber,
                contractType: selectedContract.ContractType,
                startDate: selectedContract.StartDate,
                endDate: selectedContract.EndDate,
                employeeRole: selectedContract.EmployeeRole,
                salaryGross: selectedContract.SalaryGross,
                salaryNet: selectedContract.SalaryNet,
                position: selectedContract.Position,
                jobDuties: selectedContract.JobDuties,
                department: selectedContract.Department,
                authorizedSignatory: selectedContract.AuthorizedSignatory,
                workingHoursPerWeek: selectedContract.WorkingHoursPerWeek,
                foreignTravelCompensation: selectedContract.ForeignTravelCompensation,
                contractSignedDate: selectedContract.ContractSignedDate || today,
            }));
            setInputDisable(true);
            setShowInsertBtn(false);
            setContractExist(true);
            setContractID(selectedContract.ContractID);
            if (selectedContract.ContractType === "KOHË TË PACAKTUAR") {
                setEndDateDisabled(true);
            }
        }
        else {
            setInputDisable(false);
            setShowInsertBtn(true);
            selectedContract([]);
            setContractExist(false);
            setEndDateDisabled(false);
            setContractID(null);
        }
    };


    // const handleSubmit = (e) => {
    //     e.preventDefault();
    //     const allFieldsFilled = Object.values(formData).every((value) => {
    //         if (typeof value === 'string') {
    //             return value.trim() !== '';
    //         }
    //         return value !== null && value !== undefined;
    //     });
    //     if (!allFieldsFilled) {
    //         errorAlert("Plotesoni te dhenat per ta gjeneruar kontraten")
    //         return;
    //     }
    //     onGenerate(formData, accountName, identificationNumber);
    //     handleSuccess("Kontrata u gjenerua me sukses")
    // };

    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     const allFieldsFilled = Object.entries(formData).every(([key, value]) => {
    //         if (key === 'endDate' && formData.contractType === 'KOHË TË PACAKTUAR') {
    //             return true; // lejohet të jetë bosh në këtë rast
    //         }

    //         if (typeof value === 'string') {
    //             return value.trim() !== '';
    //         }

    //         return value !== null && value !== undefined;
    //     });

    //     if (!allFieldsFilled) {
    //         errorAlert("Plotesoni te dhenat per ta gjeneruar kontraten");
    //         return;
    //     }


    //     try {
    //         const response = await axios.post(
    //             ApiLink.API_URL + "EmployeeContracts", // Kontrollo URL-në, ndoshta duhet /Create
    //             formData,
    //             {
    //                 headers
    //             }
    //         );

    //         onGenerate(formData, accountName, identificationNumber, empAddress);
    //         handleSuccess("Kontrata u gjenerua me sukses");

    //     } catch (error) {
    //         if (error.response && error.response.data) {
    //             errorAlert(``);
    //         } else {
    //             errorAlert("Gabim gjatë ruajtjes së kontratës.");
    //         }
    //         console.error(error);
    //     }
    // };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const action = e.nativeEvent.submitter?.value;

        // Nëse ekziston kontrata, mos e bëj POST-in, por gjenero vetëm kontratën
        if (contractExist && action === "showContract") {
            onGenerate(formData, accountName, identificationNumber, empAddress);
            return;
        }

        const allFieldsFilled = Object.entries(formData).every(([key, value]) => {
            if (key === 'endDate' && formData.contractType === 'KOHË TË PACAKTUAR') {
                return true;
            }

            if (typeof value === 'string') {
                return value.trim() !== '';
            }

            return value !== null && value !== undefined;
        });

        if (!allFieldsFilled) {
            errorAlert("Plotësoni të dhënat për ta gjeneruar kontratën");
            return;
        }
        // Përndryshe, bëj POST-in dhe pastaj gjenero kontratën
        try {
            let response;

            if (action === "edit") {
                const contractData = {
                    ...formData,
                };

                contractData.ContractID = contractID;
                // Endpoint për përditësim të kontratës ekzistuese
                response = await axios.put(
                    ApiLink.API_URL + `EmployeeContracts/${contractID}`, // ose `formData.accountId` nëse identifikohet me të
                    contractData,
                    { headers }
                );

                handleSuccess("Kontrata u përditësua me sukses");
            } else {
                // Endpoint për krijim të kontratës së re
                response = await axios.post(
                    ApiLink.API_URL + "EmployeeContracts",
                    formData,
                    { headers }
                );

                handleSuccess("Kontrata u gjenerua me sukses");
                getcontractByAccount(accountId, "onlyID");
            }

            // Veprime të përbashkëta pas suksesit
            onGenerate(formData, accountName, identificationNumber, empAddress);
            setShowInsertBtn(false);
            fetchAllContractByAccID();
            setContractExist(true);
            setShowEditBtn(false);

        } catch (error) {
            if (error.response && error.response.data) {
                errorAlert("Gabim: " + (error.response.data.message || "Kontrata nuk u ruajt."));
            } else {
                errorAlert("Gabim gjatë ruajtjes së kontratës.");
            }
            setContractExist(false);
        }

        // try {
        //     const response = await axios.post(
        //         ApiLink.API_URL + "EmployeeContracts",
        //         formData,
        //         { headers }
        //     );

        //     handleSuccess("Kontrata u gjenerua me sukses");
        //     onGenerate(formData, accountName, identificationNumber, empAddress);
        //     setShowInsertBtn(false);
        //     fetchAllContractByAccID();
        //     setContractExist(true);

        // } catch (error) {
        //     if (error.response && error.response.data) {
        //         errorAlert("Gabim: " + error.response.data.message || "Kontrata nuk u ruajt.");
        //         setContractExist(false);

        //     } else {
        //         errorAlert("Gabim gjatë ruajtjes së kontratës.");
        //         setContractExist(false);
        //     }
        // }
    };


    const calculateFromBruto = async (pagaBruto, llojiPagesParameter) => {
        try {
            // const DataKrahasuese = "2024-08-01";

            const kontributiPunedhenes = Number(pagaBruto * 5) / 100;
            // setKontributiPunedhenesit(kontributiPunedhenes);

            const kontributiPunetor = Number(pagaBruto * 5) / 100;
            // setKontributiPunetorit(kontributiPunetor);

            let pagaPaKontribut = Number(pagaBruto) - kontributiPunedhenes;

            let Koeficienti1 = 0;
            let Koeficienti2 = 0;
            let Koeficienti3 = 0;

            if (llojiPagesParameter === "Primare") {
                if (pagaPaKontribut <= 80) {
                    Koeficienti1 = 0;
                    Koeficienti2 = 0;
                    Koeficienti3 = 0;
                } else if (pagaPaKontribut <= 250 && pagaPaKontribut > 80) {
                    // if (date < DataKrahasuese) {
                    //     Koeficienti1 = (pagaPaKontribut - 80) * 4 / 100;
                    // }
                    // else {
                    //     Koeficienti1 = 0;
                    // }
                    Koeficienti1 = 0;
                } else if (pagaPaKontribut <= 450 && pagaPaKontribut > 250) {
                    // if (date < DataKrahasuese) {
                    //     Koeficienti1 = 6.8;
                    // }
                    // else {
                    //     Koeficienti1 = 0;
                    // }
                    Koeficienti1 = 0;
                    Koeficienti2 = (pagaPaKontribut - 250) * 8 / 100;
                } else {
                    // if (date < DataKrahasuese) {
                    //     Koeficienti1 = 6.8;
                    // }
                    // else {
                    //     Koeficienti1 = 0;
                    // }
                    Koeficienti1 = 0;
                    Koeficienti2 = 16;
                    Koeficienti3 = (pagaPaKontribut - 450) * 10 / 100;
                }
            } else if (llojiPagesParameter === "Sekondare") {
                Koeficienti3 = pagaPaKontribut * 10 / 100;
            }

            const tatimi = Koeficienti1 + Koeficienti2 + Koeficienti3;
            // setTatimiNePage(tatimi);
            var pagaNeto = (Number(pagaBruto) - kontributiPunedhenes - tatimi);

            setFormData((prev) => ({
                ...prev,
                salaryNet: pagaNeto
            }))
        } catch (error) {
            console.error("Error during calculation:", error);
            // Perform any necessary error handling here
        }
    };


    const calculateFromNeto = (pagaNeto, llojiPagesParameter) => {
        // if (invoiceNR) {
        // const DataKrahasuese = "2024-08-01";

        let Deri80 = 80;
        let Deri250 = 0;
        let Deri450 = 0;
        let Mbi450 = 0;
        let Koeficienti1 = 0;
        let Koeficienti2 = 0;
        let Koeficienti3 = 0;
        let TatimiPagaNeto = 0;

        if (llojiPagesParameter === "Primare") {
            if (pagaNeto <= 80) {
                Deri80 = pagaNeto;
            } else {
                Deri80 = 80;
                if (((Number(pagaNeto) - Number(Deri80)) / Number(0.96)) <= 170) {
                    Deri250 = ((Number(pagaNeto) - Number(Deri80)) / Number(0.96));
                    // if (date < DataKrahasuese) {
                    //     Koeficienti1 = (Number(Deri250) * Number(0.04));
                    // }
                    // else {
                    //     Koeficienti1 = 0;
                    // }
                    Koeficienti1 = 0;
                } else {
                    Deri250 = 170;
                    // if (date < DataKrahasuese) {
                    //     Koeficienti1 = (Number(Deri250) * Number(0.04));
                    // }
                    // else {
                    //     Koeficienti1 = 0;
                    // }
                    Koeficienti1 = 0;
                    if (((Number(pagaNeto) + Number(Koeficienti1) - Number(250)) / Number(0.92)) <= 200) {
                        Deri450 = (Number(pagaNeto) + Number(Koeficienti1) - Number(250)) / Number(0.92);
                        Koeficienti2 = (Number(Deri450) * Number(0.08));
                    } else {
                        Deri450 = 200;
                        Koeficienti2 = (Number(Deri450) * Number(0.08));
                        if (Deri450 === 200) {
                            Mbi450 = (Number(pagaNeto) + Number(Koeficienti1) + Number(Koeficienti2) - Number(450)) / Number(0.9);
                            Koeficienti3 = (Number(Mbi450) * Number(0.1));
                        } else {
                            Mbi450 = 0;
                        }
                    }
                }
            }
            // setTatimiNePage((Number(Koeficienti1) + Number(Koeficienti2) + Number(Koeficienti3)));
            TatimiPagaNeto = (Number(Koeficienti1) + Number(Koeficienti2) + Number(Koeficienti3) + Number(pagaNeto));

            let bruto = (Number(TatimiPagaNeto) / Number(0.95));
            // setPagaBruto(bruto);
            setFormData((prev) => ({
                ...prev,
                salaryGross: bruto
            }))
            // let kontributet = ((Number(bruto) - Number(TatimiPagaNeto)) * Number(2))

            // setKontributiPunedhenesit(Number(kontributet) / 2);
            // setKontributiPunetorit(Number(kontributet) / Number(2));
        }

        if (llojiPagesParameter === "Sekondare") {
            Mbi450 = pagaNeto / 0.9;
            Koeficienti3 = (Number(Mbi450) * Number(0.1));
            // setTatimiNePage(Koeficienti3);
            TatimiPagaNeto = (Number(Koeficienti3) + Number(pagaNeto));

            let bruto = (Number(TatimiPagaNeto) / Number(0.95));
            // setPagaBruto(bruto);
            setFormData((prev) => ({
                ...prev,
                salaryGross: bruto
            }))

            // let kontributet = ((Number(bruto) - Number(TatimiPagaNeto)) * Number(2))
            // setKontributiPunedhenesit(Number(kontributet) / 2);
            // setKontributiPunetorit(Number(kontributet) / Number(2));
        }
        // }
        // else {
        //     errorAlert("Ju lutem zgjedheni muajin fillimisht")
        // }
    };


    // const handleAutocompleteChange = (event, value) => {
    //     if (value && value.AccountID) {
    //         setfield(value); // për ruajtje lokale në state
    //         setFormData((prev) => ({
    //             ...prev,
    //             accountId: value.AccountID,
    //         }));
    //         setAccountName(value.AccountName);
    //         setIdentificationNumber(value.IdentificationNumber);
    //         setEmpAddress(value.Adress);
    //     } else {
    //         // Nëse është pastruar
    //         setfield(null);
    //         setFormData((prev) => ({
    //             ...prev,
    //             accountId: '',
    //         }));
    //         setAccountName("");
    //         setIdentificationNumber("");
    //         setEmpAddress("");
    //     }
    // };


    // const defaultProps = {
    //     options: employees,
    //     getOptionLabel: (option) =>
    //         `${option.IdentificationNumber} - ${option.AccountName}` || "",
    //     renderOption: (props, option) => (
    //         <>
    //             <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
    //                 <span>
    //                     {option.IdentificationNumber}<br />
    //                     {option.AccountName}
    //                 </span>
    //             </li>
    //         </>
    //     ),
    // };
    const handleConfirm = () => {
        setShowModal(false);
        setShowEditBtn(false);
        getcontractByAccount(accountId);
    };

    useEffect(() => {
        fetchEmployees();
        // fetchNextInvNumber();
        // fetchOwner();
    }, [])

    useEffect(() => {
        getcontractByAccount(accountId);
        fetchAllContractByAccID();
    }, [accountId])

    useEffect(() => {
        if (employees.length > 0 && accountId) {
            const employee = employees.find(emp => emp.AccountID === parseInt(accountId));
            setSelectedEmployee(employee);
            if (employee) {
                setAccountName(employee.AccountName);
                setIdentificationNumber(employee.IdentificationNumber);
                setEmpAddress(employee.Adress);
                setFormData((prev) => ({
                    ...prev,
                    accountId: accountId
                }))
            }
        }
    }, [employees, accountId]);
    return (
        <div className="employee-contract-form">
            <CancelModal
                open={showModal}
                onClose={() => setShowModal(false)}
                title="Konfirmim"
                description="Jeni të sigurt që dëshironi të anuloni ndryshimet?"
                confirmText="po"     // Custom confirm button text
                cancelText="jo"      // Custom cancel button text
                onConfirm={() => handleConfirm()}
            />
            {
                showContractSelectList ?
                    <>
                        <FormControl fullWidth>
                            <InputLabel id="contract-label" >
                                Lista e të gjitha kontratave për të punësuarin e zgjedhur
                            </InputLabel>
                            <Select
                                labelId="contract-label"
                                id="contract-select"
                                value={selectedContractId}
                                onChange={(e) => handleContractSelect(e.target.value)}
                                label="Lista e të gjitha kontratave për të punësuarin e zgjedhur"
                            >
                                {allAccountsContracts.map((contract) => (
                                    <MenuItem key={contract.ContractID} value={contract.ContractID}>
                                        {`CON-${fiscalYear}-${contract.ContractNumber} - ${contract.ContractType}`}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <hr></hr>
                    </>
                    :
                    null
            }

            <form onSubmit={handleSubmit}>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label="I punësuari"
                            name="accountName"
                            value={accountName}
                            readonly
                        />
                        {/* <Autocomplete
                        fullWidth
                        {...defaultProps}
                        id="include-input-in-list"
                        includeInputInList
                        value={field}  // Lidheni me state-in `selectedArticle`
                        onChange={handleAutocompleteChange}
                        isOptionEqualToValue={(option, value) => option.AccountID === value.AccountID} // Shto funksionin isOptionEqualToValue
                        renderInput={(params) => (
                            <TextField
                                className="AddPurchaseTotal__Container__Format__SameInput"
                                autoComplete='off'
                                {...params}
                                label="Përzgjedh të punësuarin"
                            // variant="filled"
                            //   onKeyPress={handleKeyPress}
                            />
                        )}
                        ListboxProps={{
                            style: {
                                maxHeight: '200px', // Caktoni një lartësi maksimale për të lejuar vetëm 4 elemente
                                overflow: 'auto',   // Aktivizoni scroll-in për pjesën tjetër
                            },
                        }}
                    /> */}
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label="Numri Kontratës"
                            name="contractNumber"
                            value={`CON-${fiscalYear}-${formData.contractNumber}`}
                            onChange={handleChange}
                            autoComplete='off'
                            disabled={inputDisable}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <FormControl fullWidth>
                            <InputLabel>Lloji Kontratës</InputLabel>
                            <Select
                                name="contractType"
                                value={formData.contractType}
                                label="Lloji Kontratës"
                                onChange={(e) => {
                                    const selectedValue = e.target.value;
                                    handleSelectChange('contractType', selectedValue);
                                    setEndDateDisabled(selectedValue === "KOHË TË PACAKTUAR");
                                    setShowEditBtn(true);
                                }}
                                disabled={inputDisable}

                            >
                                <MenuItem value="KOHË TË PACAKTUAR">KOHË TË PACAKTUAR</MenuItem>
                                <MenuItem value="KOHË TË CAKTUAR">KOHË TË CAKTUAR</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        {/* <TextField
                        fullWidth
                        label="Roli i të punësuarit"
                        name="employeeRole"
                        autoComplete='off'

                        value={formData.employeeRole}
                        onChange={handleChange}
                    /> */}

                        <FormControl fullWidth>
                            <InputLabel>Lloji i pagës</InputLabel>
                            <Select
                                name="employeeRole"
                                value={formData.employeeRole}
                                label="Lloji i pagës"
                                // onChange={(e) => handleSelectChange('employeeRole', e.target.value)}
                                onChange={(e) => { handleSelectChange('employeeRole', e.target.value); setShowEditBtn(true); }}
                                disabled={inputDisable}
                            >
                                <MenuItem value="Primare">Primare</MenuItem>
                                <MenuItem value="Sekondare">Sekondare</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label="Data Fillimit"
                            name="startDate"
                            type="date"
                            autoComplete='off'
                            value={formData.startDate}
                            onChange={handleChange}
                            InputLabelProps={{ shrink: true }}
                            disabled={inputDisable}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label="Data Mbarimit"
                            name="endDate"
                            type="date"
                            autoComplete='off'
                            value={formData.endDate}
                            onChange={handleChange}
                            InputLabelProps={{ shrink: true }}
                            disabled={endDateDisabled}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label="Paga Bruto"
                            name="salaryGross"
                            autoComplete="off"
                            // value={formData.salaryGross || ""}
                            value={(formData.salaryGross).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            onChange={(e) => {
                                setFormData({ ...formData, salaryGross: e.target.value });
                                calculateFromBruto(e.target.value, formData.employeeRole);
                                setShowEditBtn(true);
                            }}
                            disabled={inputDisable}
                        />

                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label="Paga Neto"
                            name="salaryNet"
                            autoComplete='off'
                            value={(formData.salaryNet).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            // onChange={handleChange}
                            disabled={inputDisable}
                            onChange={(e) => {
                                setFormData({ ...formData, salaryNet: e.target.value });
                                calculateFromNeto(e.target.value, formData.employeeRole);
                                setShowEditBtn(true);
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        {/* <TextField
                        fullWidth
                        label="Pozita"
                        name="position"
                        autoComplete='off'
                        value={formData.position}
                        onChange={handleChange}
                    /> */}

                        <Autocomplete
                            freeSolo
                            options={positions}
                            value={formData.position}
                            disabled={inputDisable}
                            onChange={(event, newValue) => {
                                setFormData({ ...formData, position: newValue });
                                setShowEditBtn(true);
                            }}
                            onInputChange={(event, newInputValue) => {
                                setFormData({ ...formData, position: newInputValue });
                                if (event?.type === 'change') {
                                    setShowEditBtn(true);
                                }
                            }}
                            ListboxProps={{
                                style: {
                                    maxHeight: '150px', // rreth 3-4 opsione, varet nga madhësia
                                    overflowY: 'auto',
                                },
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    fullWidth
                                    label="Pozita"
                                    name="position"
                                    autoComplete="off"
                                    disabled={inputDisable}
                                />
                            )}
                        />


                    </Grid>
                    <Grid item xs={12} md={6}>
                        {/* <TextField
                        fullWidth
                        label="Departmenti"
                        name="department"
                        autoComplete='off'
                        value={formData.department}
                        onChange={handleChange}
                    /> */}
                        <Autocomplete
                            freeSolo
                            options={departments} // kjo duhet të jetë një array si ['Financa', 'IT', 'Marketing', ...]
                            value={formData.department}
                            disabled={inputDisable}
                            onChange={(event, newValue) => {
                                setFormData({ ...formData, department: newValue });
                                setShowEditBtn(true);
                            }}
                            onInputChange={(event, newInputValue) => {
                                setFormData({ ...formData, department: newInputValue });
                                if (event?.type === 'change') {
                                    setShowEditBtn(true);
                                }
                            }}
                            ListboxProps={{
                                style: {
                                    maxHeight: '150px', // kufizon dropdown-in në rreth 3-4 opsione
                                    overflowY: 'auto',
                                },
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    fullWidth
                                    label="Departmenti"
                                    name="department"
                                    autoComplete="off"
                                    disabled={inputDisable}
                                />
                            )}
                        />

                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label="Orët e punës javore"
                            name="workingHoursPerWeek"
                            type="number"
                            autoComplete='off'
                            value={formData.workingHoursPerWeek}
                            onChange={handleChange}
                            disabled={inputDisable}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label="Kompensim për Udhëtime Jashtë Vendit"
                            name="foreignTravelCompensation"
                            type="number"
                            autoComplete='off'
                            value={formData.foreignTravelCompensation}
                            onChange={handleChange}
                            disabled={inputDisable}
                        />
                        {/* <FormControl fullWidth>
                        <InputLabel>Foreign Travel Compensation</InputLabel>
                        <Select
                            name="foreignTravelCompensation"
                            value={formData.foreignTravelCompensation}
                            label="Foreign Travel Compensation"
                            onChange={(e) => handleSelectChange('foreignTravelCompensation', e.target.value)}
                        >
                            <MenuItem value="Applicable">Applicable</MenuItem>
                            <MenuItem value="Not Applicable">Not Applicable</MenuItem>
                        </Select>
                    </FormControl> */}
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Data e Nënshkrimit të Kontratës"
                            name="contractSignedDate"
                            type="date"
                            autoComplete='off'
                            value={formData.contractSignedDate}
                            onChange={handleChange}
                            InputLabelProps={{ shrink: true }}
                            disabled={inputDisable}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Detyrat e Punës"
                            name="jobDuties"
                            autoComplete='off'
                            multiline
                            rows={5}
                            value={formData.jobDuties}
                            onChange={handleChange}
                            disabled={inputDisable}
                        />
                    </Grid>
                    <Grid container alignItems="center" justifyContent="space-between" spacing={2} style={{ paddingTop: "20px" }}>
                        <Grid item xs={6} sm={6} md={6} style={{ marginLeft: "25px" }}>
                            <Autocomplete
                                freeSolo
                                options={owner}
                                getOptionLabel={(option) => {
                                    if (typeof option === 'string') return option;
                                    return option?.AccountName || '';
                                }}
                                value={formData.authorizedSignatory || ''}
                                disabled={inputDisable}
                                onChange={(event, newValue) => {
                                    // newValue mund të jetë objekt ose string
                                    if (typeof newValue === 'string') {
                                        setFormData({ ...formData, authorizedSignatory: newValue });
                                        setShowEditBtn(true);
                                    } else if (newValue && typeof newValue === 'object') {
                                        setFormData({ ...formData, authorizedSignatory: newValue.AccountName });
                                        setShowEditBtn(true);
                                    } else {
                                        setFormData({ ...formData, authorizedSignatory: '' });
                                        setShowEditBtn(true);
                                    }
                                }}
                                onInputChange={(event, newInputValue) => {
                                    setFormData({ ...formData, authorizedSignatory: newInputValue });
                                    if (event?.type === 'change') {
                                        setShowEditBtn(true);
                                    }
                                }}
                                ListboxProps={{
                                    style: {
                                        maxHeight: '150px',
                                        overflowY: 'auto',
                                    },
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        fullWidth
                                        label="Përfaqësuesi zyrtar"
                                        name="authorizedSignatory"
                                        autoComplete="off"
                                        disabled={inputDisable}
                                    />
                                )}
                            />


                        </Grid>

                        <Grid item xs="auto" sx={{ display: "flex", gap: 1 }}>
                            {showInsertBtn ? (
                                // <Button variant="contained" type="submit" size="large">
                                //     Gjenero Kontratën
                                // </Button>
                                <Button
                                    variant="contained"
                                    type="submit"
                                    size="large"
                                    name="action"
                                    value="insert"
                                >
                                    Gjenero Kontratën
                                </Button>
                            ) : (
                                <>
                                    {
                                        showEditBtn ?
                                            <>
                                                {/* <Button variant="contained" color="success" type="submit" size="large">
                                                    Ruaj Ndryshimet
                                                </Button> */}
                                                <Button
                                                    variant="contained"
                                                    color="success"
                                                    type="submit"
                                                    size="large"
                                                    name="action"
                                                    value="edit"
                                                >
                                                    Ruaj Ndryshimet
                                                </Button>
                                                <Button variant="contained" color="error" size="large"
                                                    onClick={() => {
                                                        setShowModal(true);
                                                    }}>
                                                    Anulo Ndryshimet
                                                </Button>
                                            </>
                                            :
                                            <>
                                                <Button
                                                    variant="contained"
                                                    size="large"
                                                    onClick={generateNewContract}
                                                    type="button"
                                                    sx={{ mr: 1 }}
                                                >
                                                    Krijo kontrat te re
                                                </Button>

                                                <Button variant="contained" type="submit" size="large" name="action" value="showContract">
                                                    Shfaq kontraten aktuale
                                                </Button>
                                            </>
                                    }
                                    {/* <Button
                                        variant="contained"
                                        size="large"
                                        onClick={generateNewContract}
                                        type="button"
                                        sx={{ mr: 1 }}
                                    >
                                        Krijo kontrat te re
                                    </Button>

                                    <Button variant="contained" type="submit" size="large">
                                        Shfaq kontraten aktuale
                                    </Button> */}
                                </>
                            )}
                        </Grid>
                    </Grid>
                </Grid>
            </form>
        </div>
    );
};

export default ContractForm;
